<div class="login-content">
  <img
    class="close-icon"
    src="./../../../../assets/icons/x.svg"
    alt=""
    (click)="dismiss()"
  />

  <div class="login-content-logo">
    <img src="../../../../assets/logo/Logo.svg" alt="" />
  </div>
  <p class="title">Account Deleted!</p>

  <p class="paragraph2">We're sad to see you go. We hope that you will join us again.</p>

  <button class="primary-btn" (click)="dismiss()">
    OK!
  </button>
</div>
